import { tsv } from "@faire/slate/lib/tsv";

/**
 * The results grid's columns, shared by the real grid and its skeleton.
 *
 * One definition on purpose: if the skeleton's column counts drift from the
 * grid's, the layout jumps on the exact frame results land — which is the thing
 * a skeleton exists to prevent.
 */
export const resultsGridStyle = tsv({
  base: [
    "grid gap-x-4 gap-y-8",
    "grid-cols-2 md:grid-cols-3",
    "lg:grid-cols-5 xl:grid-cols-6",
  ],
});
